import queries from '@apis/queries';
import useResetPage from '@hooks/useResetPage';
import {
  DownloadableCouponRow,
  GetDownloadableCouponsParams,
} from '@models/coupon';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

function useDownloadAbleCoupons() {
  const [page, setPage] = useState<number>(0);
  const [sorter, setSorter] = useState<GetDownloadableCouponsParams['sorter']>('CreatedAtAsc');
  const params: GetDownloadableCouponsParams = {
    page,
    size: 20,
    sorter,
  };
  const [coupons, setCoupons] = useState<DownloadableCouponRow[]>([]);
  const { data, status } = useQuery(queries.coupons.downloadAble(params));
  const fetchNext = () => {
    if (status === 'success' && !data?.slice.last) {
      setPage((prev) => prev + 1);
    }
  };
  useEffect(() => {
    if (data) {
      if (data.slice.first) {
        setCoupons(data.content);
      } else {
        setCoupons((prev) => [...prev, ...data.content]);
      }
    }
  }, [data]);
  useResetPage({ params, setPage });
  return {
    coupons,
    sorter,
    setSorter,
    fetchNext,
    setPage,
  };
}

export default useDownloadAbleCoupons;
